import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  saving: false,
  // Populated from the backend via getActivityLibrary() — no local seed data.
  activities: [],
  // Default support-method picks ([[], [], [], []] — one array per wizard step),
  // set via "Set default prompting". Saved per-admin on the backend via
  // src/services/defaultPrompting.js (not client-side/localStorage).
  defaultSupports: null,
  defaultSupportsLoading: false,
};

export const activityLibraryState = createSlice({
  name: "activityLibrary",
  initialState,
  reducers: {
    setLoading(state, action) {
      return { ...state, loading: action?.payload };
    },
    setSaving(state, action) {
      return { ...state, saving: action?.payload };
    },
    setActivities(state, action) {
      return { ...state, loading: false, activities: action?.payload || [] };
    },
    setDefaultSupports(state, action) {
      return { ...state, defaultSupportsLoading: false, defaultSupports: action?.payload };
    },
    setDefaultSupportsLoading(state, action) {
      return { ...state, defaultSupportsLoading: action?.payload };
    },
    reset() {
      return initialState;
    },
  },
});

export const { setLoading, setSaving, setActivities, setDefaultSupports, setDefaultSupportsLoading } = activityLibraryState.actions;
export default activityLibraryState.reducer;
